function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { keyMap } from '@finect/front-utils/keyMap';
import { CurrentSelection } from './CurrentSelection';
import { Options } from './Options';
import { Inner } from './partials';
var getDefaultOption = function getDefaultOption(options, selected) {
  return options.find(function (element) {
    return element.id === selected;
  });
};
export var Select = function (_React$Component) {
  _inherits(Select, _React$Component);
  var _super = _createSuper(Select);
  function Select() {
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "node", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false,
      selected: getDefaultOption(_this.props.options, _this.props.selected)
    });
    _defineProperty(_assertThisInitialized(_this), "handleActionClick", function () {
      _this.setState({
        open: !_this.state.open
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (element) {
      return _this.node.contains(element.target) ? false : _this.setState({
        open: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
      if (event.keyCode === keyMap.ESCAPE) {
        _this.setState({
          open: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (option) {
      _this.setState({
        selected: option,
        open: false
      });
      _this.props.onChange(option);
    });
    return _this;
  }
  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var options = this.props.options;
      if (this.props.selected) {
        var selectedOption = options.find(function (option) {
          return option.id === _this2.props.selected;
        });
        selectedOption && this.setState({
          selected: selectedOption
        });
      }
      if (typeof document !== 'undefined') {
        document.addEventListener('mousedown', this.handleClick, false);
        document.addEventListener('keydown', this.handleKeydown, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('mousedown', this.handleClick, false);
        document.removeEventListener('keydown', this.handleKeydown, false);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (_typeof(prevState.selected) === 'object' && this.props.selected !== prevState.selected.id) {
        this.setState({
          selected: getDefaultOption(this.props.options, this.props.selected)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        _this$props$size = _this$props.size,
        size = _this$props$size === void 0 ? 'small' : _this$props$size,
        _this$props$display = _this$props.display,
        display = _this$props$display === void 0 ? 'inline-block' : _this$props$display,
        _this$props$withBorde = _this$props.withBorder,
        withBorder = _this$props$withBorde === void 0 ? true : _this$props$withBorde,
        _this$props$withPaddi = _this$props.withPadding,
        withPadding = _this$props$withPaddi === void 0 ? true : _this$props$withPaddi,
        _this$props$withZInde = _this$props.withZIndex,
        withZIndex = _this$props$withZInde === void 0 ? true : _this$props$withZInde,
        _this$props$color = _this$props.color,
        color = _this$props$color === void 0 ? 'primary' : _this$props$color,
        _this$props$chevronCo = _this$props.chevronColor,
        chevronColor = _this$props$chevronCo === void 0 ? this.props.color || 'primary' : _this$props$chevronCo,
        _this$props$backgroun = _this$props.backgroundColor,
        backgroundColor = _this$props$backgroun === void 0 ? null : _this$props$backgroun,
        _this$props$position = _this$props.position,
        position = _this$props$position === void 0 ? 'left' : _this$props$position,
        _this$props$vertical = _this$props.vertical,
        vertical = _this$props$vertical === void 0 ? false : _this$props$vertical,
        _this$props$placehold = _this$props.placeholder,
        placeholder = _this$props$placehold === void 0 ? 'Elige...' : _this$props$placehold,
        _this$props$fontWeigh = _this$props.fontWeight,
        fontWeight = _this$props$fontWeigh === void 0 ? 500 : _this$props$fontWeigh;
      var selected = this.state.selected;
      return React.createElement(Inner, {
        ref: function ref(node) {
          return _this3.node = node;
        },
        withPadding: withPadding,
        display: display,
        withZIndex: withZIndex,
        isOpen: this.state.open
      }, React.createElement(CurrentSelection, {
        fontWeight: fontWeight || 500,
        size: size,
        label: selected ? selected.label : placeholder,
        open: this.state.open,
        onClick: this.handleActionClick,
        withBorder: withBorder,
        withPadding: withPadding,
        backgroundColor: backgroundColor,
        color: color,
        chevronColor: chevronColor
      }), React.createElement(Options, {
        posX: vertical ? 'right' : 'bottom',
        vertical: vertical,
        position: position,
        display: this.props.optionsDisplay,
        options: this.props.options,
        open: this.state.open,
        onChange: this.handleChange
      }));
    }
  }]);
  return Select;
}(React.Component);